import ReviewComponent from "../components/ReviewComponent";

const Reviews = () => {
  return ( 
    <main className="web-container">
      <h1>Reviews</h1>

      <div className="reviews">
        <ReviewComponent />
      </div>
    </main>
   );
}
 
export default Reviews;